// Libraries
import {
  NgModule,
  LOCALE_ID
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import 'bootstrap/js/modal';
import { Ng2PageScrollModule } from 'ng2-page-scroll';

// Routing
import {
  AppRoutingModule,
  routingComponents
} from './app.routing';

// Modules
import { CoreModule } from './core';
import { PublicModule } from './public';
import { AdminModule } from './admin';

// Components
import { AppComponent } from './app.component';

// Environment
import { ENV_PROVIDERS } from './environment';

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    PublicModule,
    AdminModule,
    CoreModule,
    ToastModule.forRoot(),
    NgbModule.forRoot(),
    AppRoutingModule,
    Ng2PageScrollModule.forRoot()
  ],
  declarations: [
    AppComponent,
    routingComponents
  ],
  providers: [
    ENV_PROVIDERS,
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/app.module.ts